const state = function () {
    return {
      list: [],
      loading: false,
      jobModalOpen: false,
      draftStudentsLoading: false,
      draftStudents: [],
      currentJob: null,
      draftStudentModalOpen: false,
      searchFields: {
        ROSTER_JOB_ID: null,
        CLASS_ID: null,
        ROSTER_JOB_STATUS: null,
        LK_CLASS_APPROVAL_STATUS_ID: null,
      },
      rosterJobStatuses: [
        { value: 1, label: 'Processing', },
        { value: 2, label: 'Ready for Review', },
        { value: 3, label: 'Completed', },
        { value: 4, label: 'Error', },
        { value: 5, label: 'In Review', },
      ],
      approvalStatuses: [
        { value: 1, label: 'Submitted', },
        { value: 2, label: 'Approved', },
        { value: 3, label: 'Rejected', },
        { value: 4, label: 'Expired', },
        { value: 5, label: 'Resubmitted', },
        { value: 6, label: 'Not Submitted', },
        { value: 7, label: 'Completed', },
      ]
    }
}

export default {
    ...state()
}

export const initialState = state()
